import { AssetsConstant } from '@vivli/shared/infrastructure/constants';
import { CSSProperties } from 'react';
import { ButtonView } from './button.view';

const buttonStyle: CSSProperties = {
    paddingLeft: '35px',
    backgroundPosition: 'center left 15px',
    backgroundImage: `url(${AssetsConstant.WHITE_CHECK_MARK})`,
    backgroundRepeat: 'no-repeat',
};

export const SubmitButtonView = (props) => {
    return (
        <ButtonView title={'Submit'} style={buttonStyle} {...props}>
            Submit
        </ButtonView>
    );
};
